import { ElementShownAnchor } from '@hh.ru/analytics-js';
import autoInviteSnippetButtonClick from '@hh.ru/analytics-js-events/build/xhh/employer/responses/auto_invite/auto_invite_snippet_button_click';
import autoInviteSnippetElementShown from '@hh.ru/analytics-js-events/build/xhh/employer/responses/auto_invite/auto_invite_snippet_element_shown';
import { Banner, Text, Button, VSpacing, useBreakpoint } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

const TrlKeys = {
    blokoTitle: 'search.resume.autoInviteSnippet.title',
    blokoDescription: 'search.resume.autoInviteSnippet.description',
    blokoButton: 'search.resume.autoInviteSnippet.button',
    title: 'search.resume.banner.autoInvite.title',
    desc: 'search.resume.banner.autoInvite.desc',
    button: 'search.resume.banner.autoInvite.button',
};

const AutoInviteSnippet: TranslatedComponent = ({ trls }) => {
    const isAutoInvitePromo = useSelector((state) => state.resumeSearchAutoInvitePromo);
    const vacancyId = useSelector((state) => state.router.location.query.vacancy_id);

    const { isMobile } = useBreakpoint();

    if (!isAutoInvitePromo) {
        return null;
    }

    return (
        <ElementShownAnchor fn={autoInviteSnippetElementShown} vacancyId={+vacancyId}>
            <Banner
                stretched
                visible
                showBorder
                showClose={false}
                style="positive-secondary"
                buttonBase={
                    <Button
                        size="small"
                        mode="primary"
                        style="accent"
                        stretched={isMobile}
                        Element={SPALink}
                        to={`/employer/vacancyresponses/autoinvite?vacancyId=${vacancyId}&active=true`}
                        target="_blank"
                        onClick={() => autoInviteSnippetButtonClick({ vacancyId: +vacancyId })}
                    >
                        {trls[TrlKeys.button]}
                    </Button>
                }
                title={<Text typography="title-5-semibold">{trls[TrlKeys.title]}</Text>}
                content={<Text typography="paragraph-2-regular">{trls[TrlKeys.desc]}</Text>}
            />
            <VSpacing default={16} />
        </ElementShownAnchor>
    );
};

export default translation(AutoInviteSnippet);
